/* * @Author: 刘枫 * @Date: 2020-10-29 10:55:09 * @Last Modified by: 李志远 *
@Last Modified time: 2021-10-Fr 08:53:22 * @title: 商家余额提现页面 */

<template>
  <div>
    <div class="header">
      <img
        src="../../assets/images/account_logo.png"
        width="200"
      />
    </div>
    <div class="cz-con">
      <div class="inner">
        <h2>{{bonusName}} (余额{{ bonusValue }})</h2>

        <div class="content">
          <form
            action="api/user/transfer?tokenId=798cc3d3-56b0-44b2-848a-a3d6d306f253"
            name="transferForm"
            class="alipayform"
            method="POST"
            target="_blank"
          >
            <div class="element">
              <div class="msgbox">
                <p>
                  <span class="tit">提现金额：</span><input
                    type="text"
                    maxlength="60"
                    class="input"
                    name="payCode"
                    v-model="reflectMoney"
                    style="ime-mode: Disabled"
                    @input="inputCash"
                  />
                  <span style="font-weight: 100; margin-left: 23px; color: red">注：提现金额需为大于100的整数</span>
                </p>

                <p
                  style="color: #FF8000;padding-left: 168px"
                  v-if="bonusType == '56'"
                >
                  税后实际提现金额{{reflectMoney * 0.8}}
                </p>
                <p>
                  <span class="tit">支付宝名称：</span><input
                    type="text"
                    maxlength="50"
                    class="input"
                    v-model="alipayRealName"
                    @blur="inputAlipayRealName"
                    :disabled="userBankInfo.enterpriseAlipayAccountName ? true : false"
                  />
                </p>
                <p>
                  <span class="tit">支付宝账号：</span><input
                    type="text"
                    maxlength="50"
                    class="input"
                    v-model="alipayName"
                    @blur="inputAlipayName"
                    :disabled="userBankInfo.enterpriseAlipayAccountNumber ? true : false"
                  />
                </p>
                <p>
                  <span class="tit">收款人：</span><input
                    type="text"
                    maxlength="50"
                    class="input"
                    v-model="name"
                    @blur="inputName"
                    :disabled="userBankInfo.bankUserName ? true : false"
                  />
                </p>
                <p>
                  <span class="tit">开户银行地区：</span>
                  <Select
                    class="input select"
                    :disabled="userBankInfo.bankProvinceId > 0 ? true : false"
                    v-model="provinceId"
                    :label-in-value="true"
                    @on-change="getCityList($event)"
                    size="large"
                    placeholder="请选择"
                    :transfer="true"
                  >
                    <Option
                      v-for="item in provinceList"
                      :value="item.regionId"
                      :key="item.regionId"
                    >{{ item.localName }}
                    </Option>
                  </Select>
                  <Select
                    class="input select"
                    v-model="cityId"
                    :disabled="userBankInfo.bankCityId > 0 ? true : false"
                    @on-change="getBankList($event)"
                    :label-in-value="true"
                    size="large"
                    :transfer="true"
                  >
                    <Option
                      v-for="item in cityList"
                      :value="item.regionId"
                      :key="item.regionId"
                    >{{ item.localName }}
                    </Option>
                  </Select>
                </p>

                <p>
                  <span class="tit">开户银行：</span>
                  <Select
                    class="input select"
                    :disabled="userBankInfo.bankOpenId > 0 ? true : false"
                    v-model="bankOpenId"
                    :label-in-value="true"
                    @on-change="getBranchBankList($event)"
                    size="large"
                    placeholder="请选择开户行"
                    :transfer="true"
                  >
                    <Option
                      v-for="item in bankList"
                      :value="item.bankId"
                      :key="item.bankId"
                    >{{ item.bankName }}
                    </Option>
                  </Select>
                </p>

                <p>
                  <span class="tit">开户银行支行：</span>
                  <Select
                    style="width: 400px !important"
                    filterable
                    class="input select"
                    @on-change="selectBranchBank($event)"
                    :disabled="userBankInfo.branchBankOpenId > 0 ? true : false"
                    v-model="branchBankId"
                    :label-in-value="true"
                    size="large"
                    placeholder="请选择"
                    :transfer="true"
                  >
                    <Option
                      v-for="item in branchBankList"
                      :value="item.subBranchId"
                      :key="item.subBranchId"
                    >{{ item.subBranchName }}
                    </Option>
                  </Select>
                </p>
                <p>
                  <span class="tit">补充银行资料：</span>
                  <input
                    style="width: 270px;"
                    type="text"
                    maxlength="50"
                    class="input"
                    v-model="bankSupplement"
                    placeholder="如银行信息缺失的请手动输入正确银行信息"
                  />
                </p>
                <p>
                  <span class="tit">账号：</span><input
                    type="text"
                    maxlength="50"
                    class="input"
                    v-model="bankUserNo"
                    @blur="inputBankUserNo"
                    placeholder="请填写银行卡号"
                    :disabled="userBankInfo.bankUserNo ? true : false"
                  />
                </p>
                <p>
                  <span class="tit">手机号：</span><input
                    type="text"
                    maxlength="50"
                    class="input"
                    v-model="mobile"
                    @blur="inputMobile"
                    placeholder="请填写手机号"
                    :disabled="userBankInfo.phone ? true : false"
                  />
                </p>
                <p>
                  <span class="tit">身份证号：</span><input
                    type="text"
                    maxlength="50"
                    class="input"
                    v-model="number"
                    @blur="inputNumber"
                    placeholder="请填写身份证号"
                    :disabled="userBankInfo.identityCardNumber ? true : false"
                  />
                </p>
                <p><span class="tit">身份证人像面：</span></p>
                <div class="img_box">
                  <div class="demo-upload-list">
                    <Upload
                      v-if="!userBankInfo.identityCardFront"
                      :show-upload-list="false"
                      :on-exceeded-size="handleMaxSize"
                      :on-success="handleSuccessFrontImg"
                      :on-format-error="handleFormatError"
                      :format="['jpg', 'jpeg', 'png']"
                      :max-size="2048"
                      :headers="{ 'Auth-Token': upHeaders }"
                      type="drag"
                      :action="UploadUrl()"
                      style="display: inline-block; width: 150px"
                    >
                      <img
                        v-if="imageFrontImg"
                        :src="imageFrontImg"
                      />
                      <input
                        type="hidden"
                        id="imageFrontImg"
                        value="imageFrontUrl"
                      />
                      <div style="width: 150px; height: 150px; line-height: 150px">
                        <Icon
                          type="ios-camera"
                          size="40"
                        ></Icon>
                      </div>
                    </Upload>
                    <div
                      class="demo-upload-list-cover"
                      v-show="!userBankInfo.identityCardFront && imageFrontImg"
                    >
                      <Icon
                        type="ios-eye-outline"
                        @click.native="handleView(imageFrontImg)"
                      ></Icon>
                      <Icon
                        type="ios-trash-outline"
                        @click.native="handleRemoveFrontImg()"
                      ></Icon>
                    </div>
                    <img
                      v-if="userBankInfo.identityCardFront"
                      :src="imageFrontImg"
                      alt=""
                      style="width: 150px;height:150px"
                    >
                  </div>
                </div>

                <p><span class="tit">身份证国徽面：</span></p>
                <div class="img_box">
                  <div class="demo-upload-list">
                    <Upload
                      v-if="!userBankInfo.identityCardFront"
                      :show-upload-list="false"
                      :on-exceeded-size="handleMaxSize"
                      :on-success="handleSuccessBackImg"
                      :on-format-error="handleFormatError"
                      :format="['jpg', 'jpeg', 'png']"
                      :max-size="2048"
                      :headers="{ 'Auth-Token': upHeaders }"
                      type="drag"
                      :action="UploadUrl()"
                      style="display: inline-block; width: 150px"
                    >
                      <img
                        v-if="imageBackImg"
                        :src="imageBackImg"
                      />
                      <input
                        type="hidden"
                        id="imageBackImg"
                        value="imageBackUrl"
                      />
                      <div style="width: 150px; height: 150px; line-height: 150px">
                        <Icon
                          type="ios-camera"
                          size="40"
                        ></Icon>
                      </div>
                    </Upload>
                    <div
                      class="demo-upload-list-cover"
                      v-show="!userBankInfo.identityCardFront && imageFrontImg"
                    >
                      <Icon
                        type="ios-eye-outline"
                        @click.native="handleView(imageBackImg)"
                      ></Icon>
                      <Icon
                        type="ios-trash-outline"
                        @click.native="handleRemoveBackImg()"
                      ></Icon>
                    </div>
                    <img
                      v-if="userBankInfo.identityCardFront"
                      :src="imageFrontImg"
                      alt=""
                      style="width: 150px;height:150px"
                    >
                  </div>
                </div>

                <p>
                  <span class="tit">验证码：</span><input
                    type="text"
                    maxlength="6"
                    class="input"
                    onkeyup="this.value=this.value.replace(/\D/g,'')"
                    onafterpaste="this.value=this.value.replace(/\D/g,'')"
                    v-model="payCode"
                  /><span
                    class="code-sty"
                    @click="getCodeHandler"
                    v-show="codeShow"
                  >获取验证码</span>
                  <span
                    class="code-sty grey-sty"
                    v-show="!codeShow"
                  >{{ count }} s</span>
                </p>
                <p>
                  <span class="tit">
                    <div
                      class="tit_inner"
                      style="top: 0"
                    >留言信息：</div>
                  </span>
                  <textarea
                    style="width: 400px"
                    rows="4"
                    resize="vertical"
                    name="content"
                    class="ivu-input bonusTextArea"
                    placeholder=""
                    v-model="messageContent"
                    maxlength="100"
                  ></textarea>
                </p>
                <p>
                  <input
                    type="button"
                    @click="confirmBankCash"
                    class="yellow_btn"
                    value="确认提现"
                  />
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <Modal
      title="图片预览"
      v-model="visible"
    >
      <img
        :src="showImageUrl"
        v-if="visible"
        style="width: 100%"
      />
    </Modal>
  </div>
</template>
<script>
import { encryptDes } from "utils/des";
import { getSession, getNowFormatDate, isIdCard } from "utils/tool";
import { generatekey, encryptDesPost } from "utils/des-post";
import { getUserBankInfo } from "api/goods";
import {
  userWithdrawAlipay,
  getAddressInfo,
  getBankList,
  getBankBranchList,
  getWithdrawUserInfo,
} from "api/user";
import { getSettleCode } from "api/order";
export default {
  data() {
    return {
      MEMBER_HOST: process.env.PROTOCOL + "://" + process.env.MEMBER_HOST,
      cashnum: "",
      name: "",
      messageContent: "",
      alipayAccount: "",
      paypassword: "",
      bonusValue: "",
      bankUserName: "",
      bankOpenAddress: "",
      bankList: [],
      selectBank: "",
      //questionList: [],
      selectQuestion: "",
      reflectMoney: "",
      bankOpenId: "",
      branchBankId: "",
      verifyPwd: "",
      alipayName: "",
      bankUserNo: "",
      name: "",
      accountBank: "", //开户银行
      update: 1, //是否可修改提现信息1可修改 0 除提现金额和留言信息其他不可改
      timer: null,
      codeShow: true,
      count: "",
      payCode: "",
      alipayRealName: "",
      mobile: "",
      number: "",
      upHeaders: "", //图片上传请求头、
      imageFrontImg: "",
      imageBackImg: "",
      imageFrontUrl: "",
      imageBackUrl: "",
      visible: false,
      bonusType: 4,
      bonusName: "商家余额提现",
      provinceId: "",
      provinceName: "",
      cityName: "",
      cityId: "",
      bankOpenName: "",
      bankOpenBranchName: "",
      addressAll: [],
      provinceList: [],
      cityList: [],
      branchBankList: [],
      userBankInfo: {
        enterpriseAlipayAccountNumber: "",
        bankProvinceId: "",
        bankCityId: "",
        bankOpenId: "",
        branchBankOpenId: "",
        bankUserName: "",
        enterpriseAlipayAccountName: "",
        bankOpenAddress: "",
        bankUserNo: "",
        identityCardFront: "",
        identityCardBack: "",
        phone: "",
        identityCardNumber: "",
      },
    };
  },
  created() {
    this.alipayAccount = "";
    this.paypassword = "";
    this.bonusValue = this.$route.query["value"];
    this.bonusName =
      this.$route.query["type"] == 4 ? "商家余额提现" : "分享奖励提现";
    this.bonusType = this.$route.query["type"];
    if (localStorage.getItem("townList")) {
      this.addressAll = JSON.parse(localStorage.getItem("townList")).data;
      this.provinceList = JSON.parse(
        localStorage.getItem("townList")
      ).data.provinceList;
    } else {
      this.getProvinceList();
    }
    // this.returnIndex();
    this.getUserBankInfo();
    this.getUpHeaders();
  },
  methods: {
    async getProvinceList() {
      let resp = await getAddressInfo();
      this.addressAll = resp.data;
      this.provinceList = resp.data.provinceList;
      return resp.data;
    },

    // 根据省ID获取市列表
    getCityList(item) {
      if (!item.value) return;
      this.cityList = this.addressAll.cityList.filter(
        (v) => v.parentRegionId == item.value
      );
      this.provinceName = item.label.match(/[\u4e00-\u9fa5]/g).join("");
      this.cityId = "";
      this.cityName = "";
      this.bankOpenId = "";
      this.branchBankId = "";
      this.bankList = [];
      this.branchBankList = [];
    },

    getBankList(item) {
      this.bankOpenId = "";
      this.bankList = [];
      getBankList({ provinceId: this.provinceId, cityId: this.cityId }).then(
        (res) => {
          this.bankList = res.data || [];
          this.cityName = item.label.match(/[\u4e00-\u9fa5]/g).join("");
        }
      );
    },

    getBranchBankList(item) {
      this.branchBankList = [];
      this.branchBankId = "";
      console.log(this.branchBankList, "----------------------");
      setTimeout(() => {
        getBankBranchList({
          provinceId: this.provinceId,
          cityId: this.cityId,
          bankId: this.bankOpenId,
        }).then((res) => {
          this.branchBankList = res.data;
          console.log(this.branchBankList, "-----------1111111111-----------");
          this.bankOpenName = item
            ? item.label.match(/[\u4e00-\u9fa5]/g).join("")
            : "";
        });
      }, 1000);
    },

    selectBranchBank(item) {
      if (item) {
        this.bankOpenBranchName = item.label.match(/[\u4e00-\u9fa5]/g).join("");
      }
    },

    // 获取验证码点击
    getCodeHandler() {
      this.getRegisterCode();
    },

    // 获取支付验证码
    getRegisterCode() {
      //verificationCodeType："0"：支付验证码 "1"：找回密码验证码 "2"：注册验证码
      const TIME_COUNT = 60;
      if (!this.timer) {
        let data = {
          type: 5,
        };
        getSettleCode(data).then((res) => {
          if (res.resCode == 1) {
            layer.msg("验证码已发送！", { icon: 1 });
          } else {
            layer.msg(res.resDesc, { icon: 2 });
          }
        });
        this.count = TIME_COUNT;
        this.codeShow = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.codeShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },

    inputCash(e) {
      if (this.reflectMoney == 0) {
        this.reflectMoney = "";
      }
      this.reflectMoney = this.reflectMoney.replace(/[^\d]/g, ""); // 清除“数字”和“.”以外的字符
      if (this.reflectMoney.indexOf(".") < 0 && this.reflectMoney != "") {
        // reflectMoney，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.cashnum = parseInt(this.reflectMoney);
      }
      // this.reflectMoney = Number(this.reflectMoney);
    },
    inputAlipayRealName() {
      // if (!this.alipayRealName) {
      //   this.$Message.error("请填写支付宝名称");
      //   return;
      // }
      if (
        this.alipayRealName &&
        !/^[\u4e00-\u9fa5]+$/.test(this.alipayRealName)
      ) {
        this.$Message.error("支付宝名称必须为汉字，不可填写其他字符");
      }
    },

    inputAlipayName() {
      // if (!this.alipayName) {
      //   this.$Message.error("请填写支付宝账号");
      //   return;
      // }
      if (
        this.alipayName &&
        /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g.test(this.alipayName)
      ) {
        this.$Message.error("支付宝账号不能包含中文");
      }
    },

    inputName() {
      // if (!this.name) {
      //   this.$Message.error("请填写收款人");
      //   return;
      // }
      if (this.name && !/^[\u4e00-\u9fa5]{2,6}$/.test(this.name)) {
        this.$Message.error("收款人必须为2-6个汉字");
      }
    },

    inputBankOpenAddress() {
      // if (!this.bankOpenAddress) {
      //   this.$Message.error("请填写开户行名称");
      //   return;
      // }
      if (
        this.bankSupplement &&
        !/^[\u4e00-\u9fa5]+$/.test(this.bankSupplement)
      ) {
        this.$Message.error("银行信息必须为汉字");
      }
    },

    inputBankUserNo() {
      // if (!this.bankUserNo) {
      //   this.$Message.error("请填写银行卡号");
      //   return;
      // }
      if (this.bankUserNo && !/^\d{16,21}$/.test(this.bankUserNo)) {
        this.$Message.error("银行卡号必须为16-21位数字");
      }
    },

    inputMobile() {
      // if (!this.mobile) {
      //   this.$Message.error("请填写手机号");
      //   return;
      // }
      if (this.mobile && !/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.mobile)) {
        this.$Message.error("请填写正确的手机号");
      }
    },

    inputNumber() {
      // if (!this.number) {
      //   this.$Message.error("请填写身份证号码");
      //   return;
      // }
      if (this.number) {
        const data = this.number.toUpperCase();
        let flag = isIdCard(data);
        if (!flag) {
          this.$Message.error("请填写正确的身份证号码");
        }
      }
    },

    getUserBankInfo() {
      const postJson = {
        userName: getSession("userName"),
        type: this.bonusType,
      };
      getUserBankInfo(postJson).then((json) => {
        //支付宝账号 支付宝名称同步
        if (json.data) {
          this.userBankInfo = json.data;
          this.alipayName = json.data.enterpriseAlipayAccountNumber || "";
          this.provinceId = +json.data.bankProvinceId || "";
          if (this.provinceId) {
            this.cityList = this.addressAll.cityList.filter(
              (v) => v.parentRegionId == this.provinceId
            );
            this.cityId = +json.data.bankCityId || "";
            this.bankOpenId = +json.data.bankOpenId || "";

            getBankList({
              provinceId: this.provinceId,
              cityId: this.cityId,
            }).then((res) => {
              this.bankList = res.data || [];
            });

            getBankBranchList({
              provinceId: this.provinceId,
              cityId: this.cityId,
              bankId: this.bankOpenId,
            }).then((res) => {
              this.branchBankList = res.data;
            });

            this.branchBankId = json.data.branchBankOpenId || "";
          }
          this.provinceName = json.data.bankOpenArea.split(",")[0] || "";
          this.cityName = json.data.bankOpenArea.split(",")[1] || "";
          this.bankOpenName = json.data.bankOpenName || "";
          this.bankOpenBranchName = json.data.bankOpenBranchName || "";

          this.name = json.data.bankUserName || "";
          this.alipayRealName = json.data.enterpriseAlipayAccountName || "";
          this.bankOpenAddress = json.data.bankOpenAddress || "";
          this.bankUserNo = json.data.bankUserNo || "";
          this.imageFrontImg = json.data.identityCardFront || "";
          this.imageBackImg = json.data.identityCardBack || "";
          this.mobile = json.data.phone || "";
          this.number = json.data.identityCardNumber || "";
          this.bankOpenArea = json.data.bankOpenArea
        }
        getWithdrawUserInfo(1, postJson).then((json) => {
          this.alipayName = this.alipayName
            ? this.alipayName
            : json.data.alipayName;
          this.provinceId =
            this.provinceId > 0 ? this.provinceId : +json.data.bankProvinceId;
          if (this.provinceId) {
            this.cityList = this.addressAll.cityList.filter(
              (v) => v.parentRegionId == this.provinceId
            );
            this.cityId =
              this.cityId > 0 ? this.cityId : +json.data.bankCityId || "";
            this.bankOpenId =
              this.bankOpenId > 0
                ? this.bankOpenId
                : +json.data.bankOpenId || "";

            getBankList({
              provinceId: this.provinceId,
              cityId: this.cityId,
            }).then((res) => {
              this.bankList = res.data || [];
            });

            getBankBranchList({
              provinceId: this.provinceId,
              cityId: this.cityId,
              bankId: this.bankOpenId,
            }).then((res) => {
              this.branchBankList = res.data;
            });

            this.branchBankId = this.branchBankId
              ? this.branchBankId
              : json.data.branchBankOpenId;
          }
          this.provinceName = this.provinceName
            ? this.provinceName
            : json.data.bankOpenArea.split(",")[0];
          this.cityName = this.cityName
            ? this.cityName
            : json.data.bankOpenArea.split(",")[1];
          this.bankOpenName = this.bankOpenName
            ? this.bankOpenName
            : json.data.bankOpenName;
          this.bankOpenBranchName = this.bankOpenBranchName
            ? this.bankOpenBranchName
            : json.data.bankOpenBranchName;

            this.bankOpenArea = this.bankOpenArea ? this.bankOpenArea : json.data.bankOpenArea

          this.name = this.name ? this.name : json.data.bankUserName;
          this.alipayRealName = this.alipayRealName
            ? this.alipayRealName
            : json.data.realName;
          this.bankOpenAddress = this.bankOpenAddress
            ? this.bankOpenAddress
            : json.data.bankOpenAddress;
          this.bankUserNo = this.bankUserNo
            ? this.bankUserNo
            : json.data.bankUserNo;
          this.imageFrontImg = this.imageFrontImg
            ? this.imageFrontImg
            : json.data.idFrontImage;
          this.imageBackImg = this.imageBackImg
            ? this.imageBackImg
            : json.data.idBackImage;
          this.mobile = this.mobile ? this.mobile : json.data.mobile;
          this.number = this.number ? this.number : json.data.idNumber;
        });
      });
    },

    //预览
    handleView(imageUrl) {
      this.showImageUrl = imageUrl;
      this.visible = true;
    },

    //上传失败
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc: "请选择jpg、png或者jpeg.",
      });
    },

    //图片上传接口
    UploadUrl: function () {
      let actionPath = this.MEMBER_HOST + "/api/common/upload";
      return actionPath;
    },

    //设置图片上传请求头
    getUpHeaders() {
      let commonBody = {
        client: "PC",
        transeq: getNowFormatDate(),
        mac: "",
        product: "GDOMALL", // 产品类型（必传参数）
        accessSource: "PC", // 访问来源（必传参数）
        version: "1.0.0", //当前请求来源的版本号（必传参数）
        sid: getSession("sid"), // 结算返回的uid（登录状态必传参数）
      };
      this.upHeaders = encryptDes(JSON.stringify(commonBody));
    },

    // 删除
    handleRemoveFrontImg() {
      let self = this;
      layer.confirm(
        "是否确定删除?",
        {
          btn: ["确定", "取消"],
        },
        function () {
          layer.msg("删除成功", { icon: 1 });
          self.imageFrontImg = this.imageFrontUrl = null;
        },
        function () {}
      );
    },

    handleRemoveBackImg() {
      let self = this;
      layer.confirm(
        "是否确定删除?",
        {
          btn: ["确定", "取消"],
        },
        function () {
          layer.msg("删除成功", { icon: 1 });
          self.imageBackImg = this.imageBackUrl = null;
        },
        function () {}
      );
    },

    //店铺上传成功
    handleSuccessFrontImg(res, file) {
      this.$Message.success(res.resDesc);
      if (res.resCode == 1) {
        var localImage = res.data.fileDetailUrl;
        var image = res.data.fileUrl;
        this.imageFrontImg = localImage;
        this.imageFrontUrl = image;
        console.log(this.imageFrontImg, "this.imageFrontImg");
      } else {
        this.$Message.error("上传失败");
      }
    },

    handleSuccessBackImg(res, file, type) {
      this.$Message.success(res.resDesc);
      if (res.resCode == 1) {
        var localImage = res.data.fileDetailUrl;
        var image = res.data.fileUrl;
        this.imageBackImg = localImage;
        console.log(this.imageBackImg, "this.imageBackImg");
        this.imageBackUrl = image;
      } else {
        this.$Message.error("上传失败");
      }
    },

    //上传成功
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "图片大小限制",
        desc: "文件 " + file.name + "太大,不能超过 2M.",
      });
    },

    confirmBankCash() {
      if (this.reflectMoney == "" || this.reflectMoney == undefined) {
        this.$Message.error("请填写提现金额！");
        return;
      }

      if (!this.alipayRealName) {
        this.$Message.error("请填写支付宝名称");
        return;
      }

      if (
        this.alipayRealName &&
        !/^[\u4e00-\u9fa5]+$/.test(this.alipayRealName)
      ) {
        this.$Message.error("支付宝名称必须为汉字，不可填写其他字符");
        return;
      }

      if (!this.alipayName) {
        this.$Message.error("请填写支付宝账号");
        return;
      }

      if (this.alipayName && /.*[\u4e00-\u9fa5]+.*$/.test(this.alipayName)) {
        this.$Message.error("支付宝账号不能包含中文");
        return;
      }

      if (this.name == "" || this.name == undefined) {
        this.$Message.error("请填写收款人！");
        return;
      }

      if (this.name && this.name.trim().length > 0) {
        const myreg = /^[\u4e00-\u9fa5]{2,6}$/;
        if (!myreg.test(this.name)) {
          this.$Message.error("收款人必须为2-6个汉字!");
          return;
        }
      }

      if (!this.provinceId && !this.cityId) {
        this.$Message.error("请选择开户银行地区！");
        return;
      }

      if (!this.bankOpenId) {
        this.$Message.error("请选择开户银行!");
        return;
      }

      if (!this.branchBankId) {
        this.$Message.error("请选择开户银行支行!");
        return;
      }

      if (this.bankUserNo == "" || this.bankUserNo == undefined) {
        this.$Message.error("请填写银行卡号！");
        return;
      }

      if (this.bankUserNo && this.bankUserNo.trim().length > 0) {
        // 验证手机号码
        const myreg = /^\d{16,21}$/;
        if (!myreg.test(this.bankUserNo)) {
          this.$Message.error("银行卡号必须为16-21位数字!");
          return;
        }
      }
      if (this.mobile == "" || this.mobile == undefined) {
        this.$Message.error("请填写手机号！");
        return;
      }
      if (this.mobile && this.mobile.trim().length > 0) {
        // 验证手机号码
        const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!myreg.test(this.mobile)) {
          this.$Message.error("手机格式不正确!");
          return;
        }
      }

      if (!this.number) {
        this.$Message.error("请填写身份证号码");
        return;
      } else {
        const data = this.number.toUpperCase();
        let flag = isIdCard(data);
        if (!flag) {
          this.$Message.error("请填写正确的身份证号码");
          return;
        }
      }

      if (this.imageFrontImg == "" || this.imageFrontImg == undefined) {
        this.$Message.error("请上传身份证人像面！");
        return;
      }

      if (this.imageBackImg == "" || this.imageBackImg == undefined) {
        this.$Message.error("请上传身份证国徽面！");
        return;
      }
      if (this.payCode == "" || this.payCode == undefined) {
        this.$Message.error("请填写短信验证码！");
        return;
      }

      if (this.payCode && this.payCode.trim().length < 6) {
        this.$Message.error("请输入6位短信验证码！");
        return;
      }

      if (this.reflectMoney % 1 != 0) {
        this.$Message.error("金额必须是大于100的整数！");
        return;
      }

      if (this.reflectMoney < 100) {
        this.$Message.error("提现最少不能低于100！");
        return;
      }
      // }

      let self = this;
      var lock = false;
      layer.confirm(
        "是否确定提现?",
        {
          btn: ["确定", "取消"],
        },
        function () {
          if (!lock) {
            let postJson = {
              withdrawMethod: 2,
              type: self.bonusType,
              amount: self.reflectMoney,
              bankOpenAddress: self.bankOpenAddress,
              imageBack: self.imageBackImg, // 身份证反面
              imageFront: self.imageFrontImg, // 身份证正面
              mobile: self.mobile,
              number: self.number, // 身份证号
              bankOpenUserName: self.name,
              bankOpenId: self.bankOpenId,
              branchBankOpenId: self.branchBankId,
              bankProvinceId: self.provinceId,
              bankOpenArea: self.provinceName + "," + self.cityName,
              bankOpenName: self.bankOpenName,
              bankOpenBranchName: self.bankOpenBranchName,
              bankCityId: self.cityId,
              bankCard: self.bankUserNo,
              alipayName: self.alipayName,
              alipayRealName: self.alipayRealName,
              paymentCode: self.payCode,
              messageContent: self.messageContent,
              bankSupplement: self.bankSupplement,
            };
            console.log(postJson, "----------");
            lock = true; //锁定
            let key = generatekey("newSettle");
            const encrypts = encryptDesPost(JSON.stringify(postJson), key);
            userWithdrawAlipay(encrypts, 2).then((res) => {
              if (res.resCode == 1) {
                layer.msg("操作成功！", { icon: 1 });
                setTimeout(function () {
                  self.$router.push({
                    path: "/account-center",
                  });
                }, 1000);
              } else {
                layer.msg(res.resDesc, { icon: 2 });
                return;
              }
            });
          }
        },
        function () {}
      );
    },
  },
};
</script>
<style lang="less">
@import "../../assets/css/netStoreCash.less";
.input {
  min-width: 240px;
}
.select {
  padding-left: 0 !important;
  .ivu-select-selection {
    height: 30px !important;
    line-height: 30px !important;
    font-weight: 500;
    border: none;
  }
}
.code-sty {
  display: inline-block;
  padding: 5px 10px;
  background: #67c23a;
  border-radius: 2px;
  color: #fff;
  margin-left: 20px;
  cursor: pointer;
}
.grey-sty {
  background: #ddd;
  color: rgba(0, 0, 0, 0.65);
}
.msgbox {
  padding: 10px 0;
  overflow: hidden;
  .img_box {
    width: 600px;
    float: left;
  }
  .id_box {
    div {
      .no-img {
        width: 100px;
        height: 70px;
        margin: 25px auto;
      }
      // img {
      //   width: 100%;
      //   height: auto;
      // }
      span {
        display: block;
        width: 100%;
        height: 30px;
        line-height: 30px;
        background: #10aeff;
        color: #fff;
        font-size: 14px;
        text-align: center;
        position: absolute;
        bottom: 0;
      }
      span:hover {
        cursor: pointer;
      }
    }
  }
}
.demo-upload-list {
  display: inline-block;
  width: 150px;
  height: 150px !important;
  text-align: center;
  line-height: 150px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 15px;
  img {
    width: 100%;
    height: auto !important;
    // height: 100%;
  }
  .demo-upload-list-cover:hover {
    display: inline-block;
  }
  .demo-upload-list-cover {
    display: none;
    position: absolute !important;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6) !important;
    i {
      font-size: 24px;
      color: #fff;
    }
  }
}
#ivu-form {
  padding-left: 100px;
  height: 650px;
}
#ivu-form .ivu-form-item-content {
  width: 200px;
}
#ivu-form .ivu-form-item:last-child {
  margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// netStoreCash.vue?dbe5522a